import React from "react";
import { Play, Pause, Music2, X } from "lucide-react";

const ANTHEM_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_culture-archive-2/artifacts/c0fk9zvf_Asanight.WAV";

export default function AnthemPlayer() {
  const audioRef = React.useRef(null);
  const [playing, setPlaying] = React.useState(false);
  const [dismissed, setDismissed] = React.useState(false);

  const toggle = () => {
    const el = audioRef.current;
    if (!el) return;
    if (playing) {
      el.pause();
    } else {
      el.play().catch(() => {});
    }
  };

  React.useEffect(() => {
    const el = audioRef.current;
    if (!el) return;
    const onPlay = () => setPlaying(true);
    const onPause = () => setPlaying(false);
    const onEnd = () => setPlaying(false);
    el.addEventListener("play", onPlay);
    el.addEventListener("pause", onPause);
    el.addEventListener("ended", onEnd);
    return () => {
      el.removeEventListener("play", onPlay);
      el.removeEventListener("pause", onPause);
      el.removeEventListener("ended", onEnd);
    };
  }, []);

  if (dismissed) return null;

  return (
    <div className="fixed bottom-5 right-5 z-40" data-testid="anthem-player">
      <audio ref={audioRef} src={ANTHEM_URL} preload="none" />
      <div className="flex items-center gap-3 bg-forest text-cream rounded-full pl-2 pr-4 py-2 shadow-2xl shadow-night/40 border border-gold/30">
        <button
          onClick={toggle}
          data-testid="anthem-toggle-button"
          aria-label={playing ? "Pause anthem" : "Play anthem"}
          className="grid place-items-center w-11 h-11 rounded-full bg-gold text-night hover:bg-gold-light transition-colors shrink-0"
        >
          {playing ? <Pause className="w-5 h-5" /> : <Play className="w-5 h-5 translate-x-0.5" />}
        </button>
        <div className="leading-tight hidden sm:block">
          <p className="flex items-center gap-1.5 text-[10px] uppercase tracking-[0.2em] text-gold-soft">
            <Music2 className="w-3 h-3" /> {playing ? "Now Playing" : "Our Anthem"}
          </p>
          <p className="font-serif text-sm">ÀsÀNigHT Anthem</p>
        </div>
        <button
          onClick={() => {
            audioRef.current?.pause();
            setDismissed(true);
          }}
          aria-label="Hide anthem player"
          data-testid="anthem-dismiss-button"
          className="ml-1 text-cream/50 hover:text-cream transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
